import { fromOffsetDateTime, toOffsetDateTime } from "./dateTimeUtils.js";

// biome-ignore lint/complexity/noStaticOnlyClass: utility class pattern used across codebase
export class Customers {
  /**@param customer {Customer}*/
  static localizeDates(customer) {
    customer.actions.forEach((action) => {
      action.dueAt = fromOffsetDateTime(action.dueAt);
    });
    customer.investments.forEach((investment) => {
      investment.plannedDate = fromOffsetDateTime(investment.plannedDate);
    });
    return customer;
  }
  /**@param customer {Customer}*/
  static normalizeDates(customer) {
    customer.actions.forEach((action) => {
      action.dueAt = toOffsetDateTime(action.dueAt);
    });
    customer.investments.forEach((investment) => {
      investment.plannedDate = toOffsetDateTime(investment.plannedDate);
    });
    return customer;
  }
  /**@param customer {Customer}*/
  static orderListItemPositions(customer) {
    for (let i = 0; i < customer.actions.length; i++) {
      customer.actions[i].position = i + 1;
    }
    for (let i = 0; i < customer.contacts.length; i++) {
      customer.contacts[i].position = i + 1;
    }
    for (let i = 0; i < customer.investments.length; i++) {
      customer.investments[i].position = i + 1;
    }
    for (let i = 0; i < customer.addresses.length; i++) {
      customer.addresses[i].position = i + 1;
    }
  }
  /**@param customer {Customer}*/
  static normalizeOrgNumber(customer) {
    const org = customer.organizationNumber;
    if (!org)
      throw new Error(`'${customer.organizationNumber}' is not a valid organization number`);
    customer.organizationNumber = OrganizationNumbers.cleanOrgNumb(org);
  }
  /**@param customer {Customer}*/
  static validateOrgNumber(customer) {
    const err = OrganizationNumbers.validateOrgNum(customer.organizationNumber);
    if (err) return err;
  }

  /**
   * @param customer {Customer}
   * @param details {CompanyDetails}
   */
  static insertImportedInformation(customer, details) {
    if (customer.addresses.length < 1) {
      customer.addresses[0] = {
        id: -1,
        type: "DELIVERY",
        streetAddress: "",
        postalCode: "",
        city: "",
        country: "",
        note: "",
        position: 1,
      };
    }

    const address = customer.addresses[0];
    address.streetAddress = details.streetAddress;
    address.postalCode = details.postalCode;
    address.city = details.city;
    address.country = details.country;

    customer.companyName = details.companyName;
    customer.countryCode = details.countryCode;
  }
}

// biome-ignore lint/complexity/noStaticOnlyClass: utility class pattern used across codebase
export class OrganizationNumbers {
  /**@param str {string}*/
  static cleanOrgNumb(str) {
    return str.replace(/\D/g, "");
  }
  /**@param str {string}*/
  static validateOrgNum(str) {
    if (str.length < 7) return "för kort (min 7 tecken)";
    if (str.length > 11) return "för långt (max 11 tecken)";
  }
}
